import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {HttpUtils} from '../utils/http-utils';
import {SummedMasterReport} from '../domain/rb/summed-master-report.model';
import {ReportRequest} from '../domain/rb/report-request.model';
import {ReportResponse} from '../domain/rb/report-response.model';
import { Page } from '../domain/page.model';

@Injectable()
export class DashboardService {
  constructor(private httpClient: HttpClient) {
  }

  report(filter: { dateFrom: string; dateTo: string }): Observable<DashboardResponse> {
    return this.httpClient.get<DashboardResponse>(`${environment.serviceUrl}/api/dashboard/report`, {
      params: HttpUtils.getHttpParams(filter)
    });
  }

  //DASHBOARD 2.0
  public getTodaysData(): Observable<any> {
    return this.httpClient.get<any>(`${environment.serviceUrl}/api/dashboard/report/live`);
  }

  public getDataForRangePreset(range: string, offset: number): Observable<any> {
    return this.httpClient.get<any>(`${environment.serviceUrl}/api/dashboard/report/overview-presets/${range}/0`);
  }

  public getDataForCustomRange(dateTo: string, dateFrom: string): Observable<any> {
    return this.httpClient.get<any>(`${environment.serviceUrl}/api/dashboard/report/`,
    {
      params: HttpUtils.getHttpParams({dateFrom, dateTo}),
    });
  }

  //PUBLISHER DETAILS DASHBOARD
  public getPubsTodaysData(): Observable<any> {
    return this.httpClient.get<any>(`${environment.serviceUrl}/api/dashboard/report/live`);
  }

  public getPubsDataForRangePreset(range: string, publisherId: string): Observable<any> {
    return this.httpClient.get<any>(`${environment.serviceUrl}/api/dashboard/report/${publisherId}/overview-presets/${range}/0`);
  }

  public getPubsDataForCustomRange(dateTo: string, dateFrom: string, publisherId: string): Observable<any> {
    return this.httpClient.get<any>(`${environment.serviceUrl}/api/dashboard/report/${publisherId}/`,
    {
      params: HttpUtils.getHttpParams({dateFrom, dateTo}),
    });
  }

  //GET LAST IMPORT TIME
  public getLastImportTime(): Observable<any> {
    return this.httpClient.get<any>(`${environment.serviceUrl}/api/report/last-import-time`);
  }

  //GET DEMAND SOURCES DATA
  public getDemandSourcesByDate(dateTo: string, dateFrom: string, publisherId: string): Observable<any> {
    return this.httpClient.get<any>(`${environment.serviceUrl}/api/dashboard/report-publisher-top5-dp/${publisherId}/`,
    {
      params: HttpUtils.getHttpParams({dateFrom, dateTo}),
    });
  }

  public getDemandSourcesForRangePreset(range: string, publisherId: string): Observable<any> {
    return this.httpClient.get<any>(`${environment.serviceUrl}/api/dashboard/report-publisher-top5-dp/${publisherId}/presets/${range}/0`);
  }
}

export class DashboardResponse {
  publishers: SummedMasterReport[];
  domains: SummedMasterReport[];
  embeds: SummedMasterReport[];
  total: SummedMasterReport;
  apps: SummedMasterReport[];
  days: SummedMasterReport[];
  momentSources: SummedMasterReport[];
}
